import React from 'react';
import { generateAddress } from '../../../../../utils/generateAddress';
import { columnKeyMap } from '../../constants/columnKeyMap';
import CamerasCell from '../../../../common/CamerasCell/CamerasCell';
import AddressCell from '../components/AddressCell/AddressCell';

const { address } = columnKeyMap;

export const getHousesWithCameraTableColumns = ({ sortedInfo }) => {
  return [
    {
      title: 'Адрес',
      key: address,
      width: '25%',
      colSpan: 1,
      sorter: true,
      sortOrder: sortedInfo?.columnKey === address && sortedInfo?.order,
      render: (record) => <AddressCell house={record} />,
    },
    {
      key: 'cameras',
      width: '75%',
      colSpan: 1,
      render: (record) => {
        return (
          <CamerasCell houseId={record.id} address={generateAddress(record)} />
        );
      },
    },
  ];
};
